import axios from "axios";
import { useQuery, useQueryClient } from "@tanstack/react-query";

export const useFeedSearch = (query, url) => {
    const queryClient = useQueryClient();

    return useQuery({
        queryKey: ["feed-search", url ?? query],
        queryFn: () =>
            axios
                .get(
                    "/api/register/feed-search?" +
                        new URLSearchParams({
                            query: url ?? query
                        })
                )
                .then(res => res.data),
        enabled: !!(url ?? query),
        staleTime: 60 * 1000,
        initialData: () => {
            const found = queryClient
                .getQueryData(["feed-search", query])
                ?.found.filter(f => f.url === url);
            if (found && found.length) {
                return {
                    found
                };
            }
        }
    });
};

export const useFeedHost = url =>
    useQuery({
        queryKey: ["feed-host", url],
        queryFn: () =>
            axios
                .get(
                    "/api/register/feed-host?" +
                        new URLSearchParams({
                            url
                        })
                )
                .then(res => res.data),
        enabled: !!url,
        staleTime: 60 * 1000
    });
